<ng-container *ngFor="let widget of widgets;let last = last" [ngSwitch]="widget.name">
  <div [ngClass]="{'widget': !last}">
    <app-banner *ngSwitchCase="'Banner widget'" [widget]="widget"></app-banner>
    <ng-container *ngIf="environmentSettings.faqWidget">
      <app-faq *ngSwitchCase="'FAQ widget'" [widget]="widget"></app-faq>
    </ng-container>
    <app-multi-column-text-widget *ngSwitchCase="'Multi column text'" [widget]="widget">
    </app-multi-column-text-widget>
  </div>
</ng-container>